import { motion } from 'framer-motion';
import { cn } from '../../utils/cn';

interface GoogleSignInButtonProps extends Omit<React.ComponentProps<typeof motion.button>, "ref"> {
    isLoading?: boolean;
}

export default function GoogleSignInButton({ isLoading, className, ...props }: GoogleSignInButtonProps) {
    return (
        <motion.button
            whileHover={{ scale: 1.01 }}
            whileTap={{ scale: 0.98 }}
            className={cn(
                "w-full bg-white text-black font-semibold h-12 rounded-xl flex items-center justify-center gap-3 transition-all duration-300 shadow-[0_4px_12px_rgba(255,255,255,0.1)] hover:shadow-[0_4px_20px_rgba(255,255,255,0.2)] disabled:opacity-70 disabled:cursor-not-allowed",
                className
            )}
            disabled={isLoading}
            {...props}
        >
            {isLoading ? (
                <i className="ri-loader-4-line animate-spin text-xl"></i>
            ) : (
                <>
                    <i className="ri-google-fill text-xl"></i>
                    <span>Continue with Google</span>
                </>
            )}
        </motion.button>
    );
}
